import { type ReactNode } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { Link } from '@/packages/shared-ui';
import { preventDefault } from '@/packages/utils/event';

import { HeaderLayout } from '../components/HeaderLayout';
import { Subtitle } from '../components/Subtitle';
import { Title } from '../components/Title';

export function HeaderContainer(): ReactNode {
  const { title, url, subtitle } = useCardOfferDataContext();

  return (
    <HeaderLayout>
      <Link behaviour="hover_black_to_primary" href={url} onClick={preventDefault}>
        <Title text={title} />
      </Link>
      {subtitle && <Subtitle text={subtitle} />}
    </HeaderLayout>
  );
}
